import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        previous_reading: null,
        tenancy_metred_readings: {},
        tenancies: {data: [], current_page: 1, total: 0, per_page: 10},
        pending_tenancies: {data: [], current_page: 1, total: 0, per_page: 10},
        tenancy: {
            property: {
                images: [],
                price: '',
                project: {
                    name: '',
                    county: {
                        name: ''
                    },
                    charges: []
                },
                property_typology: {
                    name: ''
                }
            },
            property_unit: {
                name: ''
            },
            tenant: {
                full_name: '',
                country: {
                    name: ''
                }
            },
            payment_mode: {
                name: ''
            }
        },
        loading: false,
        metred_loading: false,
        errors: {
            data: {
                errors: {
                    status: [],
                    tenancy_date: [],
                    payment_mode_id: [],
                    property_unit_id: [],
                    property_id: [],
                    tenant_id: [],
                    user_id: [],
                    new_property_unit_id: [],
                    reason: []
                },
            }
        },
        metred_errors: {
            data: {
                errors: {
                    charge_id: [],
                    tenancy_id: [],
                    previous_reading: [],
                    current_reading: [],
                    date_from: [],
                    date_to: [],
                    units_consumed: []
                }
            }
        },
        has_errors: false,
        has_metred_errors: false,
    },
    getters: {
        loading: state => state.loading,
        metred_loading: state => state.metred_loading,
        dialogVisible: state => state.dialogVisible,
        tenancies: state => state.tenancies,
        pending_tenancies: state => state.pending_tenancies,
        errors: state => state.errors,
        metred_errors: state => state.metred_errors,
        has_errors: state => state.has_errors,
        has_metred_errors: state => state.has_metred_errors,
        tenancy: state => state.tenancy,
        tenancy_metred_readings: state => state.tenancy_metred_readings,
        previous_reading: state => state.previous_reading,
    },
    mutations: {
        setArrears(state, data) {
            state.arrears = data
        },
        setLoading(state, val) {
            state.loading = val
        },
        setMetredLoading(state, val) {
            state.metred_loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setTenancies(state, data) {
            state.tenancies = data;
        },
        setPendingTenancies(state, data) {
            state.pending_tenancies = data;
        },
        setTenancy(state, data) {
            state.tenancy = data;
        },
        setTenancyMetredReadings(state, data) {
            state.tenancy_metred_readings = data;
        },
        setPreviousReading(state, data) {
            state.previous_reading = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        setMetredErrors(state, errors) {
            state.metred_errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            status: [],
                            tenancy_date: [],
                            payment_mode_id: [],
                            property_unit_id: [],
                            property_id: [],
                            tenant_id: [],
                            user_id: [],
                            new_property_unit_id: [],
                            reason: []
                        }
                    }
                };
            }
        },
        hasMetredErrors(state, val) {
            state.has_metred_errors = val
            if (!val) {
                state.has_metred_errors = {
                    data: {
                        metred_errors: {
                            charge_id: [],
                            tenancy_id: [],
                            previous_reading: [],
                            current_reading: [],
                            date_from: [],
                            date_to: [],
                            units_consumed: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getArrearsAndDelayedPayments({commit}, filters) {
            try {
                commit('activateLoading', 'tps/list', {root: true});
                const response = await api.getArrearsAndDelayedPayments(filters);
                commit('setArrears', response.data);
                commit('deactivateLoading', 'tps/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async getTenancies({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'tenancy/list', {root: true});
                const response = await api.getTenancies(filters);
                commit('setTenancies', response.data);
                commit('setLoading', false)
                commit('deactivateLoading', 'tenancy/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getPendingTenancies({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'tenancy/list', {root: true});
                const response = await api.getPendingTenancies(filters);
                commit('setPendingTenancies', response.data);
                commit('setLoading', false)
                commit('deactivateLoading', 'tenancy/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getTenancy({commit}, id) {
            try {
                commit('activateLoading', 'tenancy/list', {root: true});
                const response = await api.getTenancy(id);
                commit('setTenancy', response.data);
                commit('deactivateLoading', 'tenancy/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getTenancyMetredReadings({commit}, id) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'tenancy/list', {root: true});
                const response = await api.getTenancyMetredReadings(id);
                commit('setTenancyMetredReadings', response.data);
                commit('setLoading', false)
                commit('deactivateLoading', 'tenancy/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getPreviousReading({commit}, data) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'tenancy/list', {root: true});
                const response = await api.getPreviousReading(data);
                commit('setPreviousReading', response.data ?? 0);
                commit('setLoading', false)
                commit('deactivateLoading', 'tenancy/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async createTenancy({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createTenancy(data);
                dispatch('getTenancies', {
                    paginate: true
                })
                commit('setLoading', false)
                ElMessage.success('Tenancy created successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async endTenancy({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.endTenancy(data);
                commit('setLoading', false)
                ElMessage.success('Tenancy ended successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async transferTenancy({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.transferTenancy(data);
                commit('setLoading', false)
                ElMessage.success('Tenant shifted to the new unit successfully!');
                dispatch('getTenancies', {paginate: true});
                return true;
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response?.data?.message || 'Unable to shift this tenant.');
                return false;
            }
        },
        async verifyTenancyInvite({commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                const response = await api.verifyTenancyInvite(data);
                commit('setLoading', false)
                return response.data;
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },
        async completeTenancyInvite({commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.completeTenancyInvite(data);
                commit('setLoading', false)
                ElMessage.success('Tenancy approved successfully!');
                if (data?.close_on_success) {
                    setTimeout(function () {
                        if (confirm("Your have successfully accepted your tenancy.")) {
                            window.open('', '_self', '');
                            window.close();
                        }
                    }, 3000);
                }
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },
        async revokePendingTenancy({dispatch}, id) {
            try {
                await api.revokePendingTenancy(id);
                ElMessage.success('Tenancy request revoked successfully.');
            } catch (e) {
                ElMessage.error(e.response?.data?.message || 'Error revoking tenancy request.');
                throw e;
            }
        },
        async resendPendingTenancyInvite({dispatch}, id) {
            try {
                await api.resendPendingTenancyInvite(id);
                ElMessage.success('Tenancy invite resent successfully.');
            } catch (e) {
                ElMessage.error(e.response?.data?.message || 'Error resending tenancy invite.');
                throw e;
            }
        },
        // Returns the fetched lease straight to the caller (unlike the two
        // actions above) - PendingTenancies.vue needs the actual content to
        // show in its preview dialog, not just a pass/fail toast.
        async previewPendingTenancyLease({dispatch}, id) {
            try {
                return await api.previewPendingTenancyLease(id);
            } catch (e) {
                ElMessage.error(e.response?.data?.message || 'Error loading lease preview.');
                throw e;
            }
        },
        async requestPayment({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.requestPayment(data);
                commit('setLoading', false)
                ElMessage.success('Payment requested successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async createMetredCharge({dispatch, commit}, data) {
            try {
                commit('setMetredLoading', true)
                commit('hasMetredErrors', false)
                await api.createMetredCharge(data);
                commit('setMetredLoading', false)
                ElMessage.success('Reading recorded successfully!');
                commit('hasMetredErrors', false)
            } catch (e) {
                commit('setMetredLoading', false)
                commit('hasMetredErrors', true)
                commit('setMetredErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editTenancy({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editTenancy(data);
                dispatch('getTenancies', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteTenancy({dispatch}, data) {
            try {
                await api.deleteTenancy(data);
                dispatch('getTenancies', {
                    paginate: true
                })
                ElMessage.success("Tenancy removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Tenancy');
                }
            }
        },
        async removeTenancy({dispatch}, data) {
            try {
                await api.removeTenancy(data);
                dispatch('getTenancies', {
                    paginate: true
                })
                ElMessage.success("Tenancy removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error removing Tenancy');
                }
            }
        },

        async exportTenanciesReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportTenanciesReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Tenancies_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        }
    }
}
